<div
  [style.display]="hourPickerVisibility"
  id="{{ hourPickerId }}"
  [class]="cardFlip"
>
  <div class="card__face card__face--front">
    <div class="container__title">
      <div class="title">
        <div *ngIf="hourPickerId === startHourPickerId">
          {{ 'sharedModule.bkgHourPicker.titleStart' | translate }}
        </div>
        <div *ngIf="hourPickerId === endHourPickerId">
          {{ 'sharedModule.bkgHourPicker.titleEnd' | translate }}
        </div>
        <img
          src="assets/images/icons/info-blue.svg"
          (click)="showInfo = true; displayBack = true"
        />
      </div>
    </div>
    <table>
      <tbody *ngIf="!customHours || customHours.length == 0">
        <tr *ngFor="let h of hours">
          <td
            id="{{ hourPickerId }}{{ h }}:{{ m }}"
            *ngFor="let m of minutes"
            (click)="onSelectHour(h, m)"
          >
            {{ h }} : {{ m }}
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="customHours && customHours.length > 0">
        <tr>
          <td
            *ngFor="let time of customHours"
            id="{{ hourPickerId }}{{ time }}"
            (click)="onSelectHourTime(time)"
          >
            {{ time }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div
    [style.display]="displayBack ? 'block' : 'none'"
    class="card__face card__face--back"
  >
    <span class="closeBtnInfo" (click)="flipCard()">
      <img src="assets/images/icons/cancel.svg"
    /></span>
    <div *ngIf="showInfo" class="info">
      <span [innerHTML]="getInfoText"> </span>
    </div>
  </div>
</div>
